import http from "./Provider";

class Enums {

    constructor() {
        this.enums = {
            WeekDays: [
                {id: 1, displayName: "Sunday", name: "sunday"},
                {id: 2, displayName: "Monday", name: "monday"},
                {id: 3, displayName: "Tuesday", name: "tuesday"},
                {id: 4, displayName: "Wednesday", name: "wednesday"},
                {id: 5, displayName: "Thursday", name: "thursday"},
                {id: 6, displayName: "Friday", name: "friday"},
                {id: 7, displayName: "Saturday", name: "saturday"},
            ],
            Months: [
                {id: 1, displayName: "January", name: "january"},
                {id: 2, displayName: "February", name: "february"},
                {id: 3, displayName: "March", name: "march"},
                {id: 4, displayName: "April", name: "april"},
                {id: 5, displayName: "May", name: "may"},
                {id: 6, displayName: "June", name: "june"},
                {id: 7, displayName: "July", name: "july"},
                {id: 8, displayName: "August", name: "august"},
                {id: 9, displayName: "September", name: "september"},
                {id: 10, displayName: "October", name: "october"},
                {id: 11, displayName: "November", name: "november"},
                {id: 12, displayName: "December", name: "december"},
            ]
        }


        ;
        this.promise = new Promise((resolve, reject) => {
            this.resolver = (val) => {
                resolve(val);
            }
        });

        this.enumMap = {
            ServiceProviders: {
                GetCallMethod: {fieldName: 'GetCallMethod', enumName: 'ServiceSentMethod'},
                ServiceProviderStatusID: {fieldName: 'ServiceProviderStatus', enumName: 'ServiceProviderStatuses'},
            },
            ServiceProviderTelephones: {
                PhonePrefixID: {fieldName: 'PhonePrefix', enumName: 'PhonePrefix'},
                Type: {fieldName: 'Type', enumName: 'PhoneNumberTypes'},
            },
            ServiceProviderAvailability: {},
            ServiceProviderWorkSchedule: {
                WorkDay: {fieldName: "WorkDay", enumName: "WeekDays"}
            },
            ServiceProviderLocationCoverage: {
                ServiceSubjectID: {fieldName: 'ServiceSubject', enumName: 'ServiceSubjects'}
            },
            ServiceProviderPaymentMethods: {
                PaymentMethodID: {fieldName: 'PaymentMethod', enumName: 'PaymentMethod'},
                Status: {fieldName: 'Status', enumName: 'PaymentMethodStatuses'}
            },
            ProviderServiceCalls: {
                ServiceCallTypeID: {fieldName: 'ServiceCallType', enumName: 'ServiceCallTypes'},
                ServiceCallStatusID: {fieldName: 'ServiceCallStatus', enumName: 'ServiceCallStatus'},
                ServiceSubjectID: {fieldName: 'ServiceSubject', enumName: 'ServiceSubjects'},
                OpeningTypeID: {fieldName: 'OpeningType', enumName: 'ServiceCallOpeningTypes'},
            },
        }
    }

    init() {

        http.get(`api/getSimulatorEnums`).then(enums => {
            this.enums = {...this.enums, ...enums};
            Object.entries(this.enums).forEach(([eName, vals]) => {
                this[eName] = {};
                // eslint-disable-next-line no-restricted-globals
                let map = self[eName] = {};
                vals.forEach(({id, name}) => {
                    map[name] = id;
                    this[eName][name] = id;
                });
            });
            this.resolver(enums);
        });

        return this.promise;
    }

    enumsInitialized() {
        return this.promise;
    }

    getAllEnums() {
        return this.enums;
    }

    getEnum(key) {
        return this.enums[key];
    }

    async fetchEnum(key) {
        await this.init();
        return this.getEnum(key);
    }
}

export default new Enums();
